export default __webpack_public_path__ + "6ed6f57683c44dcaf30df41511eba46d.png";